import { LocalStorageKey } from '@juristat/common/types'

import { useLocalStorage } from './useLocalStorage'

export function usePageSize() {
  return useLocalStorage<string>(LocalStorageKey.PaginationPageSizeState, undefined, '20')
}
